import routes from './routes';
import { AbacoWebModule } from '@abaco/web-common/src/app';

export const MODULE_ID = "outer_login_module";

export default class OuterLoginModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    readonly id = MODULE_ID;
    readonly routes = routes;
    readonly forceTopLevelRoutes = true;
}
